<script lang="ts">
export default {
  name: 'AppButtonSelect',
};
</script>

<script setup lang="ts">
import { ref, onMounted, useAttrs } from 'vue';
import { ChevronDown } from '@lucide/vue';

const attrs = useAttrs();

const props = withDefaults(
  defineProps<{
    primary?: boolean;
    loading?: boolean;
    disabled?: boolean;
    selectOptions: string[];
    dropdownPosition?: 'top' | 'bottom';
  }>(),
  {
    primary: false,
    loading: false,
    disabled: false,
    selectOptions: () => [],
    dropdownPosition: 'bottom',
  },
);

const emit = defineEmits<{
  'selectOption': [string],
}>();

// -----
// refs
// -----

const selectedOption = ref('');
const dropdown = ref<HTMLElement | null>(null);

// -----------
// lifecycles
// -----------

onMounted(() => {
  selectedOption.value = props.selectOptions[0];
});

// ----------
// functions
// ----------

function handleChooseOption(event: Event) {
  const target = event.target as HTMLAnchorElement;
  selectedOption.value = target.textContent || '';
  dropdown.value?.blur();
}
</script>

<template>
  <div class="relative join flex">
    <button
      class="btn btn-sm join-item text-white"
      :class="{
        'btn-primary': props.primary,
        'btn-disabled': props.disabled,
      }"
      @click="() => emit('selectOption', selectedOption)"
    >
      <span v-if="loading" class="loading loading-spinner"></span>
      {{ selectedOption }}
    </button>
    <div 
      class="dropdown join-item"
      :class="{
        'dropdown-left': attrs.dropdownLeft !== undefined,
        'dropdown-top': props.dropdownPosition === 'top',
        'dropdown-bottom': props.dropdownPosition === 'bottom'
      }"
    >
      <div
        tabindex="0"
        role="button"
        class="btn btn-sm p-1 rounded-tl-none rounded-bl-none opacity-90"
        :class="{
          'btn-primary': props.primary,
          'btn-disabled': props.disabled,
        }"
      >
        <ChevronDown :size="20" class="text-white" />
      </div>
      <ul
        tabindex="0"
        class="absolute dropdown-content z-1 menu bg-base-100 shadow-sm flex-nowrap w-fit-content"
        ref="dropdown"
      >
        <li v-for="option in selectOptions" :key="option">
          <a @click="handleChooseOption" class="text-black w-44">{{ option }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>
